const Website = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 4.5A2.5 2.5 0 0 0 3.5 7v10A2.5 2.5 0 0 0 6 19.5h12a2.5 2.5 0 0 0 2.5-2.5V7A2.5 2.5 0 0 0 18 4.5zM4.5 8v9A1.5 1.5 0 0 0 6 18.5h12a1.5 1.5 0 0 0 1.5-1.5V8z"
      clipRule="evenodd"
    />
  </>
)
export default Website
